/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Tabs_AuthInputs */

const en_admin_settings_tabs_auth = /** @type {(inputs: Admin_Settings_Tabs_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auth`)
};

const zh_admin_settings_tabs_auth = /** @type {(inputs: Admin_Settings_Tabs_AuthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认证`)
};

/**
* | output |
* | --- |
* | "Auth" |
*
* @param {Admin_Settings_Tabs_AuthInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_tabs_auth = /** @type {((inputs?: Admin_Settings_Tabs_AuthInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Tabs_AuthInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_tabs_auth(inputs)
	return zh_admin_settings_tabs_auth(inputs)
});
export { admin_settings_tabs_auth as "admin.settings.tabs.auth" }